import { createSelector } from 'reselect';
import { showSmnCaPpageCarouselSelector } from 'selectors/testTarget/offers/showSmnCaPpageCarousel/showSmnCaPpageCarouselSelector';

const showSelector = createSelector(showSmnCaPpageCarouselSelector, showSmnCaPpageCarousel => !!showSmnCaPpageCarousel?.show);

export { showSelector };
